import React, { useState } from 'react';
import classnames from 'classnames';
import { useDrag } from 'react-dnd';
import Icon from '../Icon';
import ConfigurationTable from './ConfigurationTable';
import DisplaySetMessageListTooltip from '../DisplaySetMessageListTooltip';

const ThumbnailNoImage = ({
  displaySetInstanceUID,
  description,
  customName,
  seriesDate,
  modality,
  modalityTooltip,
  onClick,
  onDoubleClick,
  canReject,
  onReject,
  messages,
  dragData,
  isActive,
  isHydratedForDerivedDisplaySet,
}) => {
  const [collectedProps, drag, dragPreview] = useDrag({
    type: 'displayset',
    item: { ...dragData },
    canDrag: () => Object.keys(dragData).length !== 0,
  });

  const [lastTap, setLastTap] = useState(0);

  const handleTouchEnd = e => {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - lastTap;
    if (tapLength < 300 && tapLength > 0) {
      onDoubleClick(e);
    } else {
      onClick(e);
    }
    setLastTap(currentTime);
  };

  const hasPlanning = description && !description.includes('Segmentation of morphologies');
  const isSegmentationOfMorphologies =
    description && description.includes('Segmentation of morphologies');

  // Don't render if no description at all
  if (!description || !description.trim() || isSegmentationOfMorphologies) {
    return null;
  }

  return (
    <div
      className={classnames(
        'mb-2 ml-3 flex flex-1 cursor-pointer select-none flex-row bg-white outline-none hover:border-blue-300',
        isActive ? 'border-2 border-black bg-[#8d8d8dcc]' : 'border border-black'
      )}
      style={{ padding: isActive ? '11px' : '12px', width: '240px' }}
      id={`thumbnail-${displaySetInstanceUID}`}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onTouchEnd={handleTouchEnd}
      role="button"
      tabIndex={0}
      data-cy={`study-browser-thumbnail-no-image`}
    >
      <div ref={drag}>
        <div className="flex flex-1 flex-col">
          <div className="mb-2 flex flex-1 flex-row items-center">
            {/* <Tooltip
              position="bottom"
              content={<Typography>{modalityTooltip}</Typography>}
            >
              <div
                className={classnames(
                  'rounded-sm px-3 text-lg',
                  isHydratedForDerivedDisplaySet
                    ? 'bg-primary-light text-black'
                    : 'bg-primary-main text-white'
                )}
              >
                {modality}
              </div>
            </Tooltip>
            <span className="ml-4 text-base text-blue-300">{seriesDate}</span> */}

            {isActive && (
              <div className="border-primary-light bg-primary-light ml-auto rounded pr-2 pl-2">
                <span className="font-100 text-sm">Loaded</span>
              </div>
            )}

            <DisplaySetMessageListTooltip
              messages={messages}
              id={`display-set-tooltip-${displaySetInstanceUID}`}
            />
          </div>

          <div className="flex flex-row">
            {canReject && (
              <Icon
                name="old-trash"
                style={{ minWidth: '12px' }}
                className="ml-4 w-3 text-red-500"
                onClick={onReject}
              />
            )}

            {/* Configuration Tables with overflow */}
            <div className="max-h-48 flex-1 overflow-y-auto">
              <ConfigurationTable
                description={description}
                customName={customName}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThumbnailNoImage;
